import { gcApi } from '../config/axios';
import { takeEvery, call, put } from 'redux-saga/effects';

import {
    FETCH_BENCHMARK_EXERCISES_DATA,
    FETCH_BENCHMARK_EXERCISES_DATA_FETCHING,
    FETCH_BENCHMARK_EXERCISES_DATA_SUCCESS,
    FETCH_BENCHMARK_EXERCISES_DATA_FAIL,
    SAVE_BENCHMARK_EXERCISE_DATA,
    SAVE_BENCHMARK_EXERCISE_DATA_START,
    SAVE_BENCHMARK_EXERCISE_DATA_SUCCESS,
    SAVE_BENCHMARK_EXERCISE_DATA_FAIL,
    UPDATE_BENCHMARK_EXERCISE_DATA,
    UPDATE_BENCHMARK_EXERCISE_DATA_START,
    UPDATE_BENCHMARK_EXERCISE_DATA_SUCCESS,
    UPDATE_BENCHMARK_EXERCISE_DATA_FAIL,
    DELETE_BENCHMARK_EXERCISE_DATA,
    DELETE_BENCHMARK_EXERCISE_DATA_DELETING,
    DELETE_BENCHMARK_EXERCISE_DATA_SUCCESS,
    DELETE_BENCHMARK_EXERCISE_DATA_FAIL
} from '../actions/ActionTypes';

export function* fetchBenchmarkExercisesData() {
    try {
        yield put({
            type: FETCH_BENCHMARK_EXERCISES_DATA_FETCHING
        });

        const response = yield call(gcApi.get, '/workout-service/benchmarks');

        yield put({
            type: FETCH_BENCHMARK_EXERCISES_DATA_SUCCESS,
            benchmarkExercisesData: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_BENCHMARK_EXERCISES_DATA_FAIL,
            benchmarkExercisesData: []
        });
    }
}

export function* saveBenchmarkExerciseData(action) {
    const benchmarkExercise = action.payload;
    try {
        yield put({
            type: SAVE_BENCHMARK_EXERCISE_DATA_START
        });
        yield call(gcApi.post, '/workout-service/benchmarks', benchmarkExercise);

        yield put({
            type: SAVE_BENCHMARK_EXERCISE_DATA_SUCCESS
        });

        yield call(fetchBenchmarkExercisesData);
    } catch (e) {
        yield put({
            type: SAVE_BENCHMARK_EXERCISE_DATA_FAIL
        });
    }
}

export function* updateBenchmarkExerciseData(action) {
    const benchmarkExercise = action.payload;
    try {
        yield put({
            type: UPDATE_BENCHMARK_EXERCISE_DATA_START
        });
        yield call(gcApi.put, `/workout-service/benchmarks/${benchmarkExercise.id}`, benchmarkExercise);

        yield put({
            type: UPDATE_BENCHMARK_EXERCISE_DATA_SUCCESS
        });

        yield call(fetchBenchmarkExercisesData);
    } catch (e) {
        yield put({
            type: UPDATE_BENCHMARK_EXERCISE_DATA_FAIL
        });
    }
}

export function* deleteBenchmarkExerciseData(action) {
    try {
        yield put({
            type: DELETE_BENCHMARK_EXERCISE_DATA_DELETING
        });
        yield call(gcApi.delete, `/workout-service/benchmarks/${action.payload}`);

        yield put({
            type: DELETE_BENCHMARK_EXERCISE_DATA_SUCCESS
        });
        yield call(fetchBenchmarkExercisesData);
    } catch (e) {
        yield put({
            type: DELETE_BENCHMARK_EXERCISE_DATA_FAIL
        });
    }
}

export const benchmarkExercisesSagas = [
    takeEvery(FETCH_BENCHMARK_EXERCISES_DATA, fetchBenchmarkExercisesData),
    takeEvery(SAVE_BENCHMARK_EXERCISE_DATA, saveBenchmarkExerciseData),
    takeEvery(UPDATE_BENCHMARK_EXERCISE_DATA, updateBenchmarkExerciseData),
    takeEvery(DELETE_BENCHMARK_EXERCISE_DATA, deleteBenchmarkExerciseData)
];
